// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1H5oT","col":"styles_col__2eDu3"};